// extracted by mini-css-extract-plugin
export default {"wrapper":"PopupAlert-module__wrapper--fe7f0","textWrapper":"PopupAlert-module__textWrapper--cc273"};